import { size, __spreadValues } from './chunk-JJ6VZ5V7.mjs';
import * as React from 'react';
import styled, { color } from '@xstyled/styled-components';

var SvgComponent = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  __spreadValues({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24px",
    height: "24px",
    fill: "none",
    "aria-hidden": "true",
    viewBox: "0 0 24 24"
  }, props),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "currentColor",
      d: "M9.544 7a8 8 0 0 0-7.49 5.191l-.04.107A2 2 0 0 0 3.885 15H6a2 2 0 0 0 2-2v-1a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v1a2 2 0 0 0 2 2h2.114a2 2 0 0 0 1.873-2.702l-.04-.107A8 8 0 0 0 14.457 7z"
    }
  )
);
var SvgHangUpFilled = styled(SvgComponent)`
  ${size}
  ${color}
`;
var HangUpFilled_default = SvgHangUpFilled;

export { HangUpFilled_default as default };
